import React from 'react';
import IconButton from '../IconButton/IconButton';
import { CgDollar, CgShoppingCart } from 'react-icons/cg';
import { GoClock } from 'react-icons/go';
import { BiUser } from 'react-icons/bi';
import './StatsCard.css';

const MemoizedIconButton = React.memo(({ icon: Icon }) => {
  return <IconButton icon={Icon} />;
});

const StatsCard = React.memo(({ type, value, progressValue }) => {
    let title, subtitle, Icon;

    switch (type) {
        case 'clients':
            title = 'New Clients';
            subtitle = 'Clients this month';
            Icon = BiUser;
            break;
        case 'orders':
            title = 'Active Orders';
            subtitle = 'Orders this month';
            Icon = CgShoppingCart;
            break;
        case 'tat':
            title = 'Turnaround Time';
            subtitle = 'TAT (in hrs) this month';
            Icon = GoClock;
            break;
        case 'earnings':
            title = 'Total Earnings';
            subtitle = 'Earnings this month';
            Icon = CgDollar;
            break;
        default:
            title = '';
            subtitle = '';
            Icon = null;
    }

    return (
        <div className="stats-card card border-0">
            <div className="card-body d-flex flex-column h-100" style={{ padding: '1rem' }}>

                {/* Top: Title + Icon */}
                <div className="d-flex justify-content-between align-items-start">
                    <h6 className="stats-card-title">
                        {title}
                    </h6>
                    {Icon && <MemoizedIconButton icon={Icon} />}
                </div>

                {/* Middle: Value */}
                <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                    <h2 className="stats-card-value">
                        {value}
                    </h2>
                </div>

                {/* Bottom: Subtitle + Progress */}
                <div className="d-flex align-items-center justify-content-between" style={{ marginTop: '0.5rem', gap: '8px' }}>
                    <div style={{ flexGrow: 1, overflow: 'hidden' }}>
                        <small className="stats-card-subtitle">
                            {subtitle}
                        </small>
                    </div>

                    <div className="stats-progress-box">
                        {progressValue}%
                    </div>

                </div>
            </div>
        </div>
    );
});

export default StatsCard;